const joinUnderscore = (...args) => args.join('_');

const requestProcedures = Object.entries({
    start: 'START',
    fail: 'FAIL',
    success: 'SUCCESS'
});

export const boUrlPrefix = '/bo';

export const logicalTypes = {
    TEXT: 'TEXT',
    EMAIL: 'EMAIL',
    URL: 'URL',
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    DATE: 'DATE',
    DATETIME: 'DATETIME',
    ENUM: 'ENUM',
    ENTITY: 'ENTITY'
};

export const pageInitializationActionTypes = requestProcedures.reduce((p, n) => Object.assign(p, {
    [joinUnderscore('PAGE', 'INITIALIZATION', n[1])]: n[0]
}), {});

export const pageInitializationStatus = {
    START: 'START',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS'
};

export const confirmationActionTypes = {
    open: joinUnderscore('OPEN', 'CONFIRMATION', 'MODAL'),
    close: joinUnderscore('CLOSE', 'CONFIRMATION', 'MODAL')
};

export const crudMethods = {
    create: 'POST',
    read: 'GET',
    update: 'PUT',
    delete: 'DELETE'
};


// WEBPACK FOOTER //
// ./src/app/consts.js